<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>

    
    <div class="form-edit-page row row-space">
        <div class="form-item">
            <label class="label-caption" for="nmPesquisa">Pesquisar</label>
            <input type="text" v-model="nmPesquisa" id="nmPesquisa" maxlength="50" v-uppercase />
        </div>
        <button type="button" class="buttom-icon--search" @click="lerDados" />
        <button type="button" class="buttom-icon--close" @click="closeForm" />
    </div>

    <div v-if="lsDados.length>0" class="table-wrapper">
        <table>
            <thead><tr>
                <th>Código</th>
                <th>Estabelecimento</th>
                <th>Atividade</th>
                <th>SIM</th>
            </tr></thead>
            
            <tbody><tr v-for="(obj, index) in lsDados" :key="obj.id" @click="setEstabelecimentoAtivo(obj)" 
                :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}">
                <td class="col-width-char10 right">{{ obj.cdestabelecimento }}</td>
                <td>{{ obj.nmestabelecimento }}</td>
                <td class="col-width-char40">{{ obj.nmatividade }}</td>
                <td class="col-width-char30">{{ obj.nmsim }}</td>
            </tr></tbody>
        </table>
    </div>
        
        
    <div v-if="showPagination" class="pagination">
        <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
        <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
        <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
        <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
        <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
    </div>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { globalStore } from '@/globals';

const emit = defineEmits(['close','simAlterado']);
const isLoading = ref(false);
const lsDados = ref([]);
const msgAlerta = ref(null);
const nmPesquisa = ref(null);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);


function closeForm(){emit('close')}


const lerDados = async() => {
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await Api.genericPost('/listas/estabelecimentos', {
            idep: globalStore.idep,
            idusuario: globalStore.idusuario, 
            nmpesquisar: nmPesquisa.value,
            ativo: "S"});
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
}


async function setEstabelecimentoAtivo(obj){
    try{
        const simAlterado = (globalStore.idsim != obj.idsim);
        globalStore.idestabelecimento = obj.id;
        globalStore.nmestabelecimento = obj.nmestabelecimento;
        globalStore.idsim = obj.idsim;
        globalStore.nmsim = obj.nmsim;

        const atv = await Api.genericPost('/listas/atividades', {idep: obj.idep, intparam1: obj.id});
        if (Array.isArray(atv) && atv.length > 0) {
            globalStore.atividade = atv[0];
        }

        if (simAlterado) emit('simAlterado');
        emit('close');
    } catch (error) {msgAlerta.value = `ATENÇÃO: ${error}`}
}


const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}


onMounted(lerDados)
</script>
